import { render, staticRenderFns } from "./LicenseOfferOtherServiceModal.vue?vue&type=template&id=0f2f5e85&scoped=true&"
import script from "./LicenseOfferOtherServiceModal.vue?vue&type=script&lang=js&"
export * from "./LicenseOfferOtherServiceModal.vue?vue&type=script&lang=js&"
import style0 from "./LicenseOfferOtherServiceModal.vue?vue&type=style&index=0&id=0f2f5e85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f5e85",
  null
  
)

export default component.exports